import { createSlice } from "@reduxjs/toolkit";

/** Stable cache key for admin list (page + search must match API params). */
export const adminListCacheKey = (page, search) =>
  `${Number(page)}__${encodeURIComponent(String(search ?? "").trim())}`;

const initialState = {
  user: null,
  individualAdmins: {}, // Maps cache key to { data: [], totalPages: 0 }
  organizationAdmins: {}, // Maps cache key to { data: [], totalPages: 0 }
  superAdmins: {}, // userType SuperAdmin
};

export const superAdminSlice = createSlice({
  name: "superAdmin",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action?.payload;
    },
    setAdminData: (state, action) => {
      const { type, page, data, totalPages, search = "" } = action.payload;
      const key = adminListCacheKey(page, search);
      if (type === "IndividualAdmin") {
        state.individualAdmins[key] = { data, totalPages };
      } else if (type === "OrganizationAdmin") {
        state.organizationAdmins[key] = { data, totalPages };
      } else if (type === "SuperAdmin") {
        state.superAdmins[key] = { data, totalPages };
      }
    },
    clearAdminCache: (state) => {
      state.individualAdmins = {};
      state.organizationAdmins = {};
      state.superAdmins = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, setAdminData, clearAdminCache } = superAdminSlice.actions;

export default superAdminSlice.reducer;
